// extracted by mini-css-extract-plugin
export default {"modalFooter":"Footer_modalFooter__zZgIP","saveButton":"Footer_saveButton__k9G1-"};